export default __webpack_public_path__ + "static/media/gs-3.66d335ec.png";